module.exports = {
      id: "clipboard-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#clipboard",
      toString: function () {
        return this.url;
      }
    }